export const PAGE_INFO = [
    {
        id: 0,
        page: "procurement",
        titleTab: "จัดซื้อจัดจ้าง",
        title: "จัดซื้อจัดจ้าง",
        beadcrumbSection: null,
        contactSection: null,
    },
    {
        id: 1,
        predicate: {
            announceTypeIds: [1, 10, 11]
        },
        page: "procure-plan",
        titleTab: "แผนการจัดซื้อจัดจ้าง",
        title: "แผนการจัดซื้อจัดจ้าง",
        beadcrumbSection: `<div style="display: inline">
                            <ul class="list-inline Beadcrumb-inline">
                            <li><a href="https://www.sec.or.th/TH/Pages/HOME.aspx">Home</a></li>
                            <li> &gt; &nbsp;<a href="/AboutUs/Procurement">เกี่ยวกับ ก.ล.ต.</a></li>
                            <li> &gt; &nbsp;<a href="/AboutUs/Procurement">จัดชื้อจัดจ้าง</a></li>
                            <li> &gt; &nbsp;<a href="/AboutUs/Procure-Plan">แผนการจัดซื้อจัดจ้าง</a></li>
                            </ul>
                            </div>`,
        contactSection: `  <div class="contact-Titile">
                                <span>ติดต่อสอบถามข้อมูลเพิ่มเติม</span>
                            </div>             
                            <div class="ms-rtestate-field" style="display:inline">
                            <p>
                                <span class="ms-rteThemeFontFace-14" style="font-size:10pt;">
                                    ​​​​​​​​​​​​​​​​ฝ่ายการเงินและบริหารทั่วไป
                                    <br />
                                    <span class="ms-rteThemeFontFace-14" style="font-size:10pt;">โทรศัพท์&nbsp;</span>
                                    <span class="ms-rteThemeFontFace-14" style="font-size:10pt;">
                                    0-2033-9971​​​
                                    <br />
                                    </span>
                                </span>
                            </p>
                            </div>`,
    },
    {
        id: 2,
        predicate: {
            announceTypeIds: [2]
        },
        page: "procurement-estimate",
        titleTab: "ประกาศราคากลาง",
        title: "ประกาศราคากลาง",
        beadcrumbSection: `<div style="display: inline">
                            <ul class="list-inline Beadcrumb-inline">
                            <li><a href="https://www.sec.or.th/TH/Pages/HOME.aspx">Home</a></li>
                            <li> &gt; &nbsp;<a href="/AboutUs/Procurement">เกี่ยวกับ ก.ล.ต.</a></li>
                            <li> &gt; &nbsp;<a href="/AboutUs/Procurement">จัดชื้อจัดจ้าง</a></li>
                            <li> &gt; &nbsp;<a href="/AboutUs/Procurement-Estimate">ประกาศราคากลาง</a></li>
                            </ul>
                            </div>`,
        contactSection: `  <div class="contact-Titile">
                                <span>ติดต่อสอบถามข้อมูลเพิ่มเติม</span>
                            </div>             
                            <div class="ms-rtestate-field" style="display:inline">
                            <p>
                                <span class="ms-rteThemeFontFace-14" style="font-size:10pt;">
                                    ​​​​​​​​​​​​​​​​ฝ่ายการเงินและบริหารทั่วไป
                                    <br />
                                    <span class="ms-rteThemeFontFace-14" style="font-size:10pt;">โทรศัพท์&nbsp;</span>
                                    <span class="ms-rteThemeFontFace-14" style="font-size:10pt;">
                                    0-2033-9971​​​
                                    <br />
                                    </span>
                                </span>
                            </p>
                            </div>`,
    },
    {
        id: 3,
        predicate: {
            announceTypeIds: [3]
        },
        page: "ProcureTOR",
        titleTab: "ประกาศร่าง TOR",
        title: "ประกาศร่าง TOR",
        beadcrumbSection: `<div style="display: inline">
                            <ul class="list-inline Beadcrumb-inline">
                            <li><a href="https://www.sec.or.th/TH/Pages/HOME.aspx">Home</a></li>
                            <li> &gt; &nbsp;<a href="/AboutUs/Procurement">เกี่ยวกับ ก.ล.ต.</a></li>
                            <li> &gt; &nbsp;<a href="/AboutUs/Procurement">จัดชื้อจัดจ้าง</a></li>
                            <li> &gt; &nbsp;<a href="/AboutUs/ProcureTOR">ประกาศร่าง TOR</a></li>
                            </ul>
                            </div>`,
        contactSection: `  <div class="contact-Titile">
                                <span>ติดต่อสอบถามข้อมูลเพิ่มเติม</span>
                            </div>             
                            <div class="ms-rtestate-field" style="display:inline">
                            <p>​​​​​​​​<span class="ms-rteFontSize-10" style="color:#000000;"><span style="color:#000000;">ข้อมูลประกาศร่าง TOR&nbsp; นี้ สำหรับเผยแพร่รับฟังความคิดเห็น&nbsp;</span></span></p>
                            <p><span class="ms-rteFontSize-10" style="color:#000000;"><span style="color:#000000;">หากมีความคิดเห็น </span></span><span class="ms-rteFontSize-10" style="color:#000000;"><span style="color:#000000;">สามารถส่งได้ทาง&nbsp; email:&nbsp; purchase@sec.or.th </span></span><span class="ms-rteFontSize-10" style="color:#000000;"><span style="color:#000000;">ภายใน 3&nbsp; วันทำการ นับตั้งแต่วันที่เผยแพร่ข้อมูล</span></span><br style="color:#000000;"></p>
                            <p>
                                <span class="ms-rteThemeFontFace-14" style="font-size:10pt;">
                                    ​​​​​​​​​​​​​​​​ฝ่ายการเงินและบริหารทั่วไป
                                    <br />
                                    <span class="ms-rteThemeFontFace-14" style="font-size:10pt;">โทรศัพท์&nbsp;</span>
                                    <span class="ms-rteThemeFontFace-14" style="font-size:10pt;">
                                    0-2033-9971​​​
                                    <br />
                                    </span>
                                </span>
                            </p>
                            </div>`,
    },
    {
        id: 4,
        predicate: {
            announceTypeIds: [4, 6, 8]
        },
        page: "procure-announce",
        titleTab: "ประกาศเชิญชวน",
        title: "ประกาศเชิญชวน",
        beadcrumbSection: `<div style="display: inline">
                            <ul class="list-inline Beadcrumb-inline">
                            <li><a href="https://www.sec.or.th/TH/Pages/HOME.aspx">Home</a></li>
                            <li> &gt; &nbsp;<a href="/AboutUs/Procurement">เกี่ยวกับ ก.ล.ต.</a></li>
                            <li> &gt; &nbsp;<a href="/AboutUs/Procurement">จัดชื้อจัดจ้าง</a></li>
                            <li> &gt; &nbsp;<a href="/AboutUs/Procure-Announce">ประกาศเชิญชวน</a></li>
                            </ul>
                            </div>`,
        contactSection: `  <div class="contact-Titile">
                                <span>ติดต่อสอบถามข้อมูลเพิ่มเติม</span>
                            </div>             
                            <div class="ms-rtestate-field" style="display:inline">
                            <p>
                                <span class="ms-rteThemeFontFace-14" style="font-size:10pt;">
                                    ​​​​​​​​​​​​​​​​ฝ่ายการเงินและบริหารทั่วไป
                                    <br />
                                    <span class="ms-rteThemeFontFace-14" style="font-size:10pt;">โทรศัพท์&nbsp;</span>
                                    <span class="ms-rteThemeFontFace-14" style="font-size:10pt;">
                                    0-2033-9971​​​
                                    <br />
                                    </span>
                                </span>
                            </p>
                            </div>`,
    },
    {
        id: 5,
        predicate: {
            announceTypeIds: [5, 7, 9]
        },
        page: 'procure-bidresult',
        titleTab: 'ประกาศผู้ชนะการเสนอราคา',
        title: 'ประกาศผู้ชนะการเสนอราคา'
    },
    {
        id: 6,
        predicate: {
            announceTypeIds: [12]
        },
        page: 'procure-result',
        titleTab: 'ผลการจัดซื้อจัดจ้าง',
        title: 'ผลการจัดซื้อจัดจ้าง'
    },
    {
        id: 7,
        predicate: {
            announceTypeIds: [13]
        },
        page: 'procure-contract',
        titleTab: 'ข้อมูลสาระสำคัญในสัญญา',
        title: 'ข้อมูลสาระสำคัญในสัญญา'
    },
    {
        id: 8,
        predicate: {
            announceTypeIds: [14]
        },
        page: 'procure-result-analysis',
        titleTab: 'รายงานการวิเคราะห์ผลการจัดซื้อจัดจ้าง',
        title: 'รายงานการวิเคราะห์ผลการจัดซื้อจัดจ้าง'
    }
]

